var _style, _rect, _path, _line, _rect2, _circle, _circle2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMouseResetDoubleclick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 240",
    width: 240,
    height: 240,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes dblClick {\n      0%, 8% { fill: #888; }\n      10%, 16% { fill: #444; }\n      18%, 22% { fill: #888; }\n      24%, 30% { fill: #444; }\n      32%, 100% { fill: #888; }\n    }\n    @keyframes r1 {\n      0%, 10% { r: 6; opacity: 0; }\n      18% { r: 6; opacity: 0.9; }\n      38% { r: 15; opacity: 0; }\n      100% { opacity: 0; }\n    }\n    @keyframes r2 {\n      0%, 30% { r: 6; opacity: 0; }\n      32% { r: 6; opacity: 0.9; }\n      52% { r: 15; opacity: 0; }\n      100% { opacity: 0; }\n    }\n    @keyframes x2pop {\n      0%, 10% { opacity: 0; }\n      18% { opacity: 1; }\n      32% { opacity: 1; }\n      52% { opacity: 0; }\n      100% { opacity: 0; }\n    }\n    .lb { animation: dblClick 3s ease-in-out infinite; }\n    .rg1 { animation: r1 3s ease-out infinite; }\n    .rg2 { animation: r2 3s ease-out infinite; }\n    .x2 { animation: x2pop 3s ease-in-out infinite; }\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 52,
    width: 84,
    height: 136,
    rx: 42,
    ry: 42,
    fill: "#888",
    stroke: "#999",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "lb",
    d: "M120,52 A42,42 0 0,0 78,94 L78,108 L120,108 Z",
    stroke: "#999",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: 52,
    x2: 120,
    y2: 108,
    stroke: "#999",
    strokeWidth: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 78,
    width: 16,
    height: 36,
    rx: 8,
    fill: "#bbb"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "rg1",
    cx: 100,
    cy: 78,
    r: 6,
    fill: "none",
    stroke: "#999",
    strokeWidth: 2.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "rg2",
    cx: 100,
    cy: 78,
    r: 6,
    fill: "none",
    stroke: "#999",
    strokeWidth: 2.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "x2"
  }, /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 84,
    fontFamily: "-apple-system, Helvetica, Arial, sans-serif",
    fontSize: 16,
    fontWeight: 700,
    fill: "#666",
    textAnchor: "middle"
  }, "\xD72"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouseResetDoubleclick);
export default __webpack_public_path__ + "static/media/mouse-reset-doubleclick.7e520e333b4902b944146845f76156f6.svg";
export { ForwardRef as ReactComponent };